var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import utility components
import moment from 'moment/moment';
// - Import action types
import { PostActionType } from 'constants/postActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
import { provider } from 'src/socialEngine';
/**
 * Get service providers
 */
var postService = provider.get(SocialProviderTypes.PostService);
/* _____________ CRUD DB _____________ */
/**
 * Add a normal post
 */
export var dbAddPost = function (newPost, callBack) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var post = {
            postTypeId: 0,
            creationDate: moment().unix(),
            deleteDate: 0,
            score: 0,
            fabric: '',
            Inventory: {},
            Description: '',
            price: 0,
            viewCount: 0,
            body: newPost.body,
            ownerUserId: uid,
            ownerDisplayName: newPost.ownerDisplayName,
            ownerAvatar: newPost.ownerAvatar,
            lastEditDate: 0,
            tags: newPost.tags || [],
            commentCounter: 0,
            comments: {},
            Sales: {},
            votes: {},
            image: '',
            imageFullPath: '',
            video: '',
            disableComments: newPost.disableComments,
            disableSharing: newPost.disableSharing,
            deleted: false
        };
        return postService.addPost(post).then(function (postKey) {
            dispatch(addPost(uid, __assign({}, post, { id: postKey })));
            callBack();
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
/**
 * Add a post with image
 */
export var dbAddImagePost = function (newPost, callBack) {
    return function (dispatch, getState) {
        dispatch(globalActions.showTopLoading());
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var post = {
            postTypeId: 1,
            creationDate: moment().unix(),
            deleteDate: 0,
            score: 0,
            viewCount: 0,
            fabric: newPost.fabric || 'cotton default',
            Inventory: newPost.Inventory,
            ShippingPrice: newPost.ShippingPrice,
            Description: newPost.Description || 'No Description',
            price: newPost.price || 95,
            DesignName: newPost.DesignName || 'Hoodie',
            color: newPost.color || 'Red',
            ownerMerchantId: newPost.ownerMerchantId,
            ArFile: newPost.ArFile || '',
            available: false,
            isOwnerVerified: newPost.isOwnerVerified || false,
            Type: newPost.Type || '',
            body: newPost.body,
            ownerUserId: uid,
            ownerDisplayName: newPost.ownerDisplayName,
            ownerAvatar: newPost.ownerAvatar,
            lastEditDate: 0,
            tags: newPost.tags || [],
            commentCounter: 0,
            image: newPost.image || '',
            imageArr: newPost.imageArr || [],
            imageFullPathArr: newPost.imageFullPathArr || [],
            imageFullPath: newPost.imageFullPath || '',
            video: '',
            disableComments: newPost.disableComments ? newPost.disableComments : false,
            disableSharing: newPost.disableSharing ? newPost.disableSharing : false,
            deleted: false,
        };
        postService.addPost(post).then(function (postKey) {
            dispatch(addPost(uid, __assign({}, post, { id: postKey })));
            callBack(postKey);
            dispatch(globalActions.hideTopLoading());
            return postKey;
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
export var dbAddGLTFPost = function (newPost, callBack) {
    return function (dispatch, getState) {
        dispatch(globalActions.showTopLoading());
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var post = {
            postTypeId: 2,
            creationDate: moment().unix(),
            deleteDate: 0,
            score: 0,
            viewCount: 0,
            fabric: newPost.fabric || 'cotton default',
            Inventory: newPost.Inventory,
            ShippingPrice: newPost.ShippingPrice || 7.75,
            Description: newPost.Description || 'No Description',
            DesignName: newPost.DesignName || '',
            color: newPost.color || 'Red',
            ownerMerchantId: newPost.ownerMerchantId,
            ArFile: newPost.ArFile || '',
            available: false,
            isOwnerVerified: newPost.isOwnerVerified || false,
            Type: newPost.Type || '',
            body: newPost.body,
            ownerUserId: uid,
            ownerDisplayName: newPost.ownerDisplayName,
            ownerAvatar: newPost.ownerAvatar,
            lastEditDate: 0,
            tags: newPost.tags || [],
            commentCounter: 0,
            image: newPost.image || '',
            imageArr: newPost.imageArr || [],
            imageFullPathArr: newPost.imageFullPathArr || [],
            GLTF: newPost.GLTF || '',
            imageFullPath: newPost.imageFullPath || '',
            video: '',
            disableComments: newPost.disableComments ? newPost.disableComments : false,
            disableSharing: newPost.disableSharing ? newPost.disableSharing : false,
            deleted: false,
        };
        return postService.addPost(post).then(function (postKey) {
            dispatch(addPost(uid, __assign({}, post, { id: postKey })));
            callBack();
            dispatch(globalActions.hideTopLoading());
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
/**
 * Update a post from database
 */
export var dbUpdatePost = function (updatedPost, callBack) {
    return function (dispatch, getState) {
        dispatch(globalActions.showTopLoading());
        return postService.updatePost(updatedPost.toJS()).then(function () {
            dispatch(updatePost(updatedPost));
            callBack();
            dispatch(globalActions.hideTopLoading());
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.message));
            dispatch(globalActions.hideTopLoading());
        });
    };
};
/**
 * Delete a post from database
 * @param  {string} id is post identifier
 */
export var dbDeletePost = function (id) {
    return function (dispatch, getState) {
        dispatch(globalActions.showTopLoading());
        var state = getState();
        // Get current user id
        var uid = state.getIn(['authorize', 'uid']);
        return postService.deletePost(id).then(function () {
            dispatch(deletePost(uid, id));
            dispatch(globalActions.hideTopLoading());
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.message));
            dispatch(globalActions.hideTopLoading());
        });
    };
};
/**
 * Get all user posts from data base
 */
export var dbGetPosts = function (page, limit) {
    if (page === void 0) { page = 0; }
    if (limit === void 0) { limit = 5; }
    return function (dispatch, getState) {
        var state = getState();
        var stream = state.getIn(['post', 'stream']);
        var lastPageRequest = stream.get('lastPageRequest');
        var lastPostId = stream.get('lastPostId');
        var uid = state.getIn(['authorize', 'uid']);
        if (uid && lastPageRequest !== page) {
            return postService.getPosts(uid, lastPostId, page, limit).then(function (result) {
                if (!result.posts || !(result.posts.length > 0)) {
                    return dispatch(notMoreDataStream());
                }
                // Store last post Id
                dispatch(lastPostStream(result.newLastPostId));
                var parsedData = {};
                result.posts.forEach(function (post) {
                    var _a, _b;
                    var postId = Object.keys(post)[0];
                    var postData = post[postId];
                    var ownerId = postData.ownerUserId;
                    parsedData = __assign({}, parsedData, (_a = {}, _a[ownerId] = __assign({}, parsedData[ownerId], (_b = {}, _b[postId] = __assign({}, postData), _b)), _a));
                });
                dispatch(addPosts(parsedData));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/**
 * Get all user posts from data base
 */
// For profile page
export var dbGetPostsByUserId = function (userId, page, limit) {
    if (page === void 0) { page = 0; }
    if (limit === void 0) { limit = 10; }
    return function (dispatch, getState) {
        var state = getState();
        var profile = state.get('post').profile;
        var lastPageRequest = state.getIn(['post', 'profile', userId, 'lastPageRequest'], -1);
        var lastPostId = state.getIn(['post', 'profile', userId, 'lastPostId'], '');
        var uid = state.getIn(['authorize', 'uid']);
        if (lastPageRequest !== page) {
            return postService.getPostsByUserId(userId, lastPostId, page, limit).then(function (result) {
                if (!result.posts || !(result.posts.length > 0)) {
                    return dispatch(notMoreDataProfile(userId));
                }
                // Store last post Id
                dispatch(lastPostProfile(userId, result.newLastPostId));
                var parsedData = {};
                result.posts.forEach(function (post) {
                    var _a, _b;
                    var postId = Object.keys(post)[0];
                    var postData = post[postId];
                    var ownerId = postData.ownerUserId;
                    parsedData = __assign({}, parsedData, (_a = {}, _a[ownerId] = __assign({}, parsedData[ownerId], (_b = {}, _b[postId] = __assign({}, postData), _b)), _a));
                });
                dispatch(addPosts(parsedData));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
export var dbGetPostsByUserName = function (userName, page, limit) {
    if (page === void 0) { page = 0; }
    if (limit === void 0) { limit = 10; }
    return function (dispatch, getState) {
        var state = getState();
        var profile = state.get('post').profile;
        var lastPageRequest = state.getIn(['post', 'profile', userName, 'lastPageRequest'], -1);
        var lastPostId = state.getIn(['post', 'profile', userName, 'lastPostId'], '');
        var uid = state.getIn(['authorize', 'uid']);
        if (lastPageRequest !== page) {
            return postService.getPostsByUserName(userName, lastPostId, page, limit).then(function (result) {
                if (!result.posts || !(result.posts.length > 0)) {
                    return dispatch(notMoreDataProfile(userName));
                }
                // Store last post Id
                dispatch(lastPostProfile(userName, result.newLastPostId));
                var parsedData = {};
                result.posts.forEach(function (post) {
                    var _a, _b;
                    var postId = Object.keys(post)[0];
                    var postData = post[postId];
                    var ownerId = postData.ownerUserId;
                    parsedData = __assign({}, parsedData, (_a = {}, _a[ownerId] = __assign({}, parsedData[ownerId], (_b = {}, _b[postId] = __assign({}, postData), _b)), _a));
                });
                dispatch(addPosts(parsedData));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
export var dbGetPostsByType = function (Type, page, limit) {
    if (page === void 0) { page = 0; }
    // fix limit bug
    return function (dispatch, getState) {
        var state = getState();
        var profile = state.get('post').profile;
        var lastPageRequest = state.getIn(['post', 'profile', Type, 'lastPageRequest'], -1);
        var lastPostId = state.getIn(['post', 'profile', Type, 'lastPostId'], '');
        var uid = state.getIn(['authorize', 'uid']);
        // if (uid && lastPageRequest !== page) {
        return postService.getPostsByType(Type, lastPostId, page, limit).then(function (result) {
            if (!result.posts || !(result.posts.length > 0)) {
                return dispatch(notMoreDataProfile(Type));
            }
            // Store last post Id
            dispatch(lastPostProfile(Type, result.newLastPostId));
            var parsedData = {};
            result.posts.forEach(function (post) {
                var _a, _b;
                var postId = Object.keys(post)[0];
                var postData = post[postId];
                var ownerId = postData.ownerUserId;
                parsedData = __assign({}, parsedData, (_a = {}, _a[ownerId] = __assign({}, parsedData[ownerId], (_b = {}, _b[postId] = __assign({}, postData), _b)), _a));
            });
            dispatch(addFilteredPosts(parsedData, Type));
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.message));
        });
        // }
    };
};
export var dbGetPostsByConstraints = function (Type, Constraint, page, limit) {
    if (page === void 0) { page = 0; }
    if (limit === void 0) { limit = 30; }
    // fix limit bug
    return function (dispatch, getState) {
        var state = getState();
        var profile = state.get('post').profile;
        var lastPageRequest = state.getIn(['post', 'profile', Type, 'lastPageRequest'], -1);
        var lastPostId = state.getIn(['post', 'profile', Type, 'lastPostId'], '');
        var uid = state.getIn(['authorize', 'uid']);
        // if (uid && lastPageRequest !== page) {
        return postService.getPostsByConstraints(Type, Constraint, lastPostId, page, limit).then(function (result) {
            if (!result.posts || !(result.posts.length > 0)) {
                return dispatch(notMoreDataProfile(Type));
            }
            // Store last post Id
            dispatch(lastPostProfile(Type, result.newLastPostId));
            var parsedData = {};
            result.posts.forEach(function (post) {
                var _a, _b;
                var postId = Object.keys(post)[0];
                var postData = post[postId];
                var ownerId = postData.ownerUserId;
                parsedData = __assign({}, parsedData, (_a = {}, _a[ownerId] = __assign({}, parsedData[ownerId], (_b = {}, _b[postId] = __assign({}, postData), _b)), _a));
            });
            dispatch(addFilteredPosts(parsedData, Type));
        })
            .catch(function (error) {
            dispatch(globalActions.showMessage(error.message));
        });
        // }
    };
};
/**
 * Get all user posts from data base
 */
export var dbGetPostById = function (uid, postId) {
    return function (dispatch, getState) {
        if (uid) {
            return postService.getPostById(postId).then(function (post) {
                dispatch(addPost(uid, post));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/**
 * Get all user purchases from data base
 */
export var dbGetPurchases = function (userId, page, limit) {
    if (page === void 0) { page = 0; }
    if (limit === void 0) { limit = 10; }
    return function (dispatch, getState) {
        var state = getState();
        var profile = state.get('post').profile;
        var lastPageRequest = state.getIn(['post', 'profile', userId, 'lastPageRequest'], -1);
        var lastPostId = state.getIn(['post', 'profile', userId, 'lastPostId'], '');
        var uid = state.getIn(['authorize', 'uid']);
        if (uid && lastPageRequest !== page) {
            return postService.getPurchases(userId, lastPostId, page, limit).then(function (result) {
                if (!result.posts || !(result.posts.length > 0)) {
                    return dispatch(notMoreDataProfile(userId));
                }
                // Store last post Id
                dispatch(lastPostProfile(userId, result.newLastPostId));
                var parsedData = {};
                result.posts.forEach(function (post) {
                    var _a, _b;
                    var postId = Object.keys(post)[0];
                    var postData = post[postId];
                    var ownerId = postData.ownerUserId;
                    parsedData = __assign({}, parsedData, (_a = {}, _a[ownerId] = __assign({}, parsedData[ownerId], (_b = {}, _b[postId] = __assign({}, postData), _b)), _a));
                });
                alert('working');
                console.log('parsed', parsedData);
                dispatch(addPosts(parsedData));
            })
                .catch(function (error) {
                dispatch(globalActions.showMessage(error.message));
            });
        }
    };
};
/* _____________ CRUD State _____________ */
/**
 * Add a normal post
 */
export var addPost = function (uid, post) {
    return {
        type: PostActionType.ADD_POST,
        payload: { uid: uid, post: post }
    };
};
/**
 * Update a post
 */
export var updatePost = function (post) {
    return {
        type: PostActionType.UPDATE_POST,
        payload: { post: post }
    };
};
/**
 * Update the comments of post
 */
export var updatePostComments = function (comments) {
    return {
        type: PostActionType.UPDATE_POST,
        payload: comments
    };
};
/**
 * Update the votes of post
 */
export var updatePostVotes = function (votes) {
    return {
        type: PostActionType.UPDATE_POST,
        payload: votes
    };
};
/**
 * Delete a post
 */
export var deletePost = function (uid, id) {
    return {
        type: PostActionType.DELETE_POST,
        payload: { uid: uid, id: id }
    };
};
/**
 * Add a list of post
 */
export var addPosts = function (userPosts) {
    return {
        type: PostActionType.ADD_LIST_POST,
        payload: { userPosts: userPosts }
    };
};
export var addFilteredPosts = function (userPosts, type) {
    return {
        type: PostActionType.ADD_FILTERED_POST,
        payload: { userPosts: userPosts, type: type }
    };
};
export var clearFilteredState = function () {
    return {
        type: PostActionType.CLEAR_FILTERED_STATE
    };
};
/**
 * Clea all data in post store
 */
export var clearAllData = function () {
    return {
        type: PostActionType.CLEAR_ALL_DATA_POST
    };
};
/**
 * Add a post with image
 */
export var addImagePost = function (uid, post) {
    return {
        type: PostActionType.ADD_IMAGE_POST,
        payload: { uid: uid, post: post }
    };
};
/**
 * Set stream has more data to show
 */
export var hasMoreDataStream = function () {
    return {
        type: PostActionType.HAS_MORE_DATA_STREAM
    };
};
/**
 * Set stream has not data any more to show
 */
export var notMoreDataStream = function () {
    return {
        type: PostActionType.NOT_MORE_DATA_STREAM
    };
};
/**
 * Set last page request of stream
 */
export var requestPageStream = function (page) {
    return {
        type: PostActionType.REQUEST_PAGE_STREAM,
        payload: { page: page }
    };
};
/**
 * Set last post identification of stream
 */
export var lastPostStream = function (lastPostId) {
    return {
        type: PostActionType.LAST_POST_STREAM,
        payload: { lastPostId: lastPostId }
    };
};
/**
 * Set profile posts has more data to show
 */
export var hasMoreDataProfile = function () {
    return {
        type: PostActionType.HAS_MORE_DATA_PROFILE
    };
};
/**
 * Set profile posts has not data any more to show
 */
export var notMoreDataProfile = function (userId) {
    return {
        type: PostActionType.NOT_MORE_DATA_PROFILE,
        payload: { userId: userId }
    };
};
/**
 * Set last page request of profile posts
 */
export var requestPageProfile = function (userId, page) {
    return {
        type: PostActionType.REQUEST_PAGE_PROFILE,
        payload: { userId: userId, page: page }
    };
};
/**
 * Set last post identification of profile posts
 */
export var lastPostProfile = function (userId, lastPostId) {
    return {
        type: PostActionType.LAST_POST_PROFILE,
        payload: { userId: userId, lastPostId: lastPostId }
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/postActions.ts
// module id = 186
// module chunks = 50